"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package import
 */
const react_1 = __importStar(require("react"));
const crumble_1 = require("@oclock/crumble");
const react_table_1 = require("react-table");
/**
 * Local import
 */
const CreateDialog_1 = __importDefault(require("src/components/Instances/CreateDialog"));
// types
const types_1 = require("src/store/apis/types");
// style
const S = __importStar(require("./style"));
const DeleteDialog_1 = __importDefault(require("src/components/Instances/DeleteDialog"));
const InstancesTable = ({ data, refetchInstances }) => {
    const [isCreateOpen, setIsCreateOpen] = (0, react_1.useState)(false);
    const [isDeleteOpen, setIsDeleteOpen] = (0, react_1.useState)(null);
    const tableData = (0, react_1.useMemo)(() => data.filter((instance) => instance.statut !== types_1.InstanceStatus.disabled), [data]);
    const columns = (0, react_1.useMemo)(() => [
        { Header: 'Nom', accessor: 'orga' },
        { Header: 'URL', accessor: 'base_url', Cell: ({ row }) => react_1.default.createElement("a", { target: "_blank", href: row.values['base_url'] }, row.values['base_url']) },
        { Header: 'Port', accessor: 'port' },
        { Header: ' ', Cell: ({ row }) => (react_1.default.createElement(S.IconContainer, null,
                react_1.default.createElement(S.IconButton, { onClick: () => {
                        console.log(row);
                        setIsDeleteOpen(row.values.orga);
                    } },
                    react_1.default.createElement(crumble_1.Icon, { name: "TrashAlt", color: "#1C64F2", size: "20px" })))) }
    ], []);
    const tableInstance = (0, react_table_1.useTable)({
        columns,
        data: tableData,
    }, react_table_1.useGlobalFilter, react_table_1.useSortBy);
    const handleChangeSearch = (evt) => tableInstance.setGlobalFilter(evt.target.value);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.Header, null,
            react_1.default.createElement(S.Header, null,
                react_1.default.createElement(S.SearchInput, null,
                    react_1.default.createElement(crumble_1.InputField, { placeholder: "Recherche", type: "text", value: tableInstance.state.globalFilter || '', onChange: handleChangeSearch })),
                react_1.default.createElement("p", null,
                    tableInstance.rows.length,
                    " instances")),
            react_1.default.createElement(crumble_1.Button, { onClick: () => setIsCreateOpen(true), icon: "Plus" }, "Ajouter une instance")),
        isCreateOpen && react_1.default.createElement(CreateDialog_1.default, { setOpen: setIsCreateOpen, refetchInstances: refetchInstances }),
        isDeleteOpen && react_1.default.createElement(DeleteDialog_1.default, { setOpen: setIsDeleteOpen, refetchInstances: refetchInstances, instanceName: isDeleteOpen }),
        react_1.default.createElement(S.TableContainer, null,
            react_1.default.createElement(crumble_1.Table, { tableInstance: tableInstance }))));
};
exports.default = InstancesTable;
